module.exports = __webpack_public_path__ + "img/donut-chart.59291ab1.svg";